// Or from '@reduxjs/toolkit/query' if not using the auto-generated hooks
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { getValidToken } from "../auth/keycloack";

// initialize an empty api service that we'll inject endpoints into later as needed
export const getwelcomApi = createApi({
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_API_BASEURL,
    prepareHeaders: async (headers, { getState }) => {
      const token = await getValidToken();
      // If we have a token set in state, let's assume that we should be passing it.
      if (token) {
        headers.set("authorization", `Bearer ${token}`);
      }

      return headers;
    },
  }),
  endpoints: () => ({}),
});
